import { useMutation, useQueryClient } from "@tanstack/react-query";

import { deleteFootprintingDairyByPrimaryDataId, deleteFootprintingDairyByPrimaryDataIdAdmin } from "services";

import { footprintingDairyPrimaryQueryKeys, getEnvironment, invalidateAndRefecthQueries } from "utils";

import {
  FOOTPRINTING_CROP_PRIMARY_DATA,
  FOOTPRINTING_DAIRY_COWS_SOLD,
  FOOTPRINTING_DAIRY_FEED_ADDITIVE,
  FOOTPRINTING_DAIRY_FEED_INFORMATION,
  FOOTPRINTING_DAIRY_FEED_PRODUCTION,
  FOOTPRINTING_DAIRY_HERD_DETAILS,
  FOOTPRINTING_DAIRY_HERD_SIZE,
  FOOTPRINTING_DAIRY_MANURE_ADDITIVE,
  FOOTPRINTING_DAIRY_MANURE_STORAGE,
} from "consts";

export const useDeleteFootprintingDairyByPrimaryDataId = (farmId: string, year: number, primaryDataId?: string, feedInformationId?: string) => {
  const isAdmin = getEnvironment().admin;
  const queryClient = useQueryClient();

  return useMutation({
    mutationKey: [FOOTPRINTING_CROP_PRIMARY_DATA],
    mutationFn: () => {
      if (!primaryDataId) return Promise.resolve(null);
      return isAdmin ? deleteFootprintingDairyByPrimaryDataIdAdmin(primaryDataId) : deleteFootprintingDairyByPrimaryDataId(primaryDataId);
    },
    onSuccess: async () => {
      invalidateAndRefecthQueries(queryClient, [
        // All the extra keys clean up the mess of stuff from this now-deleted data
        [FOOTPRINTING_DAIRY_COWS_SOLD, primaryDataId, isAdmin],
        [FOOTPRINTING_DAIRY_FEED_ADDITIVE, primaryDataId, isAdmin],
        [FOOTPRINTING_DAIRY_FEED_INFORMATION, feedInformationId, isAdmin],
        [FOOTPRINTING_DAIRY_FEED_PRODUCTION, feedInformationId, isAdmin],
        [FOOTPRINTING_DAIRY_HERD_DETAILS, primaryDataId, isAdmin],
        [FOOTPRINTING_DAIRY_HERD_SIZE, primaryDataId, isAdmin],
        [FOOTPRINTING_DAIRY_MANURE_ADDITIVE, primaryDataId, isAdmin],
        [FOOTPRINTING_DAIRY_MANURE_STORAGE, primaryDataId, isAdmin],
        ...footprintingDairyPrimaryQueryKeys(primaryDataId ?? "", farmId, year, isAdmin),
      ]);
    },
  });
};
